"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _context = require("./context");

var sideMenuSpacerStyles = function sideMenuSpacerStyles(t) {
  return (0, _emotion.css)({
    display: "block",
    width: 0,
    height: t("spacerHeight")
  });
};
/**
 * This component can be used to add spacing between links in a side menu. Place this as a
 * child of the SideMenu component.
 */


var SideMenuSpacer = function SideMenuSpacer() {
  return /*#__PURE__*/_react["default"].createElement(_context.Consumer, null, function (_ref) {
    var t = _ref.t;
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: sideMenuSpacerStyles(t),
      role: "presentation"
    });
  });
};

var _default = SideMenuSpacer;
exports["default"] = _default;